import { render, staticRenderFns } from "./CustomActionsSummaryModal.vue?vue&type=template&id=48ec703d&scoped=true&"
import script from "./CustomActionsSummaryModal.vue?vue&type=script&lang=js&"
export * from "./CustomActionsSummaryModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomActionsSummaryModal.vue?vue&type=style&index=0&id=48ec703d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ec703d",
  null
  
)

export default component.exports